import { useTranslation } from 'react-i18next';

import { PageLayout, PageTitle } from 'core/components';
import { SelectionCountProvider } from 'core/states';
import { JobList } from 'jobs/components';

export const JobListPage = () => {
  const { t } = useTranslation();

  return (
    <PageLayout title={t('titleJobs')}>
      <SelectionCountProvider>
        <PageTitle title={t('titleJobs')} />
        <JobList />
      </SelectionCountProvider>
    </PageLayout>
  );
};
